export const SETANGLESECTIONLINE = 'SETANGLESECTIONLINE'

interface SetAngleSectionLine {
  type: typeof SETANGLESECTIONLINE
  payload: {
    n: number
  }
}

export const setAngleSectionLine = (n: number): SetAngleSectionLine => ({
  type: SETANGLESECTIONLINE,
  payload: {
    n,
  },
})

export type countActionTypes = SetAngleSectionLine
